import React, { useEffect, useState } from 'react';
import { Megaphone, AlertTriangle, CheckCircle2, X } from 'lucide-react';
import api from '../api/api';

const TYPE_STYLES = {
  info: { bar: 'bg-blue-600', Icon: Megaphone },
  warning: { bar: 'bg-amber-500', Icon: AlertTriangle },
  success: { bar: 'bg-green-600', Icon: CheckCircle2 },
  urgent: { bar: 'bg-red-600', Icon: AlertTriangle },
};

const AnnouncementBanner = () => {
  const [announcement, setAnnouncement] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const fetchAnnouncement = async () => {
      try {
        const res = await api.get('/announcement/active');
        const a = res.data.announcement;
        if (a && !sessionStorage.getItem(`ann-dismiss-${a.updated_at || a.message}`)) {
          setAnnouncement(a);
        }
      } catch (_) { /* banner is best-effort */ }
    };
    fetchAnnouncement();
  }, []);

  if (!announcement || dismissed) return null;
  const { bar, Icon } = TYPE_STYLES[announcement.type] || TYPE_STYLES.info;
  const dismissKey = `ann-dismiss-${announcement.updated_at || announcement.message}`;

  return (
    <div className={`${bar} text-white px-4 py-2.5 flex items-center gap-3`} role="status" data-testid="announcement-banner">
      <Icon size={16} className="flex-shrink-0" />
      <p className="flex-1 text-sm font-medium break-words" data-testid="announcement-message">{announcement.message}</p>
      <button
        onClick={() => { sessionStorage.setItem(dismissKey, '1'); setDismissed(true); }}
        className="p-1 hover:bg-white/20 rounded flex-shrink-0 transition-colors"
        aria-label="Dismiss announcement"
        data-testid="announcement-dismiss-btn"
      >
        <X size={16} />
      </button>
    </div>
  );
};

export default AnnouncementBanner;
